import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'
import { setupRouterGuards } from './router/guards'
import i18n from './i18n'
import { initFirebase } from './config'
import { offlineSyncService } from './services/offlineSyncService'

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(pinia)
app.use(router)
app.use(i18n)

setupRouterGuards(router)

initFirebase()

if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/'
      })
      console.log('Service Worker registered:', registration.scope)

      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data.type === 'SYNC_PENDING_OPERATIONS') {
          offlineSyncService.sync()
        }
      })
    } catch (error) {
      console.error('Service Worker registration failed:', error)
    }
  })
}

window.addEventListener('online', () => {
  console.log('Back online, syncing...')
  offlineSyncService.sync()
})

offlineSyncService.startPeriodicSync(60000)

app.mount('#app')
